import { MessageCircle, Instagram, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="grain relative bg-[#0F1E19] pt-16 pb-28 text-[#FBF9F4] md:pb-10" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="grid gap-10 md:grid-cols-2">
          <div className="flex flex-col items-center text-center">
            <img
              src="/logo-ivory.webp"
              alt="شعار UCURE Professional الرسمي"
              className="h-28 w-auto"
              data-testid="footer-logo"
            />
            <p className="font-serif-ar mt-4 text-lg text-[#9BD8BC]">عناية تصنع الفرق ✦</p>
            <p className="mt-1 text-xs italic text-[#FBF9F4]/50" dir="ltr">
              Des soins qui font la différence
            </p>
          </div>
          <div>
            <h3 className="text-sm font-black tracking-widest text-[#D4AF37]">تواصل معنا</h3>
            <a
              href="https://wa.me/212689067964?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%D9%8B%D8%8C%20%D8%A3%D8%B1%D9%8A%D8%AF%20%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D9%81%D8%B3%D8%A7%D8%B1%20%D8%B9%D9%86%20%D8%A8%D8%AE%D8%A7%D8%AE%20%D9%8A%D9%88%D9%83%D9%8A%D9%88%D8%B1"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="mt-4 flex w-fit items-center gap-2.5 whitespace-nowrap rounded-full bg-[#2E9E6B] px-5 py-2.5 text-sm font-bold text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#1F7A52] hover:shadow-lg hover:shadow-emerald-900/30"
            >
              <MessageCircle className="h-4 w-4" />
              راسلنا على واتساب
            </a>
            <p className="mt-2.5 text-xs text-[#FBF9F4]/60">
              متاحون للرد على استفساراتك ·{" "}
              <a
                href="tel:0689067964"
                data-testid="footer-phone-link"
                className="inline-flex items-center gap-1 font-bold text-[#FBF9F4]/80 transition-colors hover:text-[#9BD8BC]"
                dir="ltr"
              >
                <Phone className="h-3 w-3" />
                0689067964
              </a>
            </p>
            <a
              href="https://instagram.com/ucureprofessional"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              className="mt-3 flex w-fit items-center gap-2 text-sm text-[#FBF9F4]/70 transition-colors hover:text-[#9BD8BC]"
              dir="ltr"
            >
              <Instagram className="h-4 w-4" />
              @UCUREPROFESSIONAL
            </a>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-[#FBF9F4]/10 pt-6 text-xs text-[#FBF9F4]/40 sm:flex-row">
          <p>© 2026 UCURE Professional — جميع الحقوق محفوظة</p>
          <p dir="ltr" className="tracking-[0.3em]">STOP · CURE · CARE</p>
          <a
            href="/admin/orders"
            data-testid="footer-admin-link"
            className="text-[#FBF9F4]/40 transition-colors hover:text-[#9BD8BC]"
          >
            لوحة الطلبات
          </a>
        </div>
      </div>
    </footer>
  );
}
